import { Observable } from 'zen-observable-ts';

export type Unsubscribe = { unsubscribe: () => void };

export interface IEventManager {
  on(event: string, listener: (...args: any[]) => void): Unsubscribe;
  emit(event: string, ...args: any[]): void;
  clearAllListeners(): void;
}

export const Event = {
  INIT: 'init',
  TOKEN_EXPIRED: 'token_expired',
  TOKEN_REFRESH_FAILED: 'token_refresh_failed',
} as const;

type Event = (typeof Event)[keyof typeof Event];

export class EventManager implements IEventManager {
  private readonly events = new Map<Event, Observable<any>>();
  private readonly subscriptions = new Map<Event, any>();

  public on(event: Event, listener: (...args: any[]) => void): Unsubscribe {
    if (!this.events.has(event)) {
      this.events.set(
        event,
        new Observable<any>((observer) => {
          this.subscriptions.set(event, observer);
        })
      );
    }

    const subscription = this.events.get(event)?.subscribe(listener);

    return {
      unsubscribe: () => {
        subscription?.unsubscribe();
        this.subscriptions.delete(event);
        this.events.delete(event);
      },
    };
  }

  public emit(event: Event, ...args: any[]): void {
    const observer = this.subscriptions.get(event);
    if (observer) {
      observer.next(...args);
    }
  }

  public clearAllListeners(): void {
    this.subscriptions.forEach((subscription, key) => {
      subscription.complete();
      this.subscriptions.delete(key);
      this.events.delete(key);
    });
  }
}
